import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=57cc568c&scoped=true"
import script from "./order-detail.js?vue&type=script&lang=js&external"
export * from "./order-detail.js?vue&type=script&lang=js&external"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=57cc568c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc568c",
  null
  
)

export default component.exports